import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import { ProductosEliminar, ProductosListar } from "../../../configuracion/apiUrls";

const EliminarProducto = ({ datos, token, setListaProductos, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(() => {
        if (eliminar)
            eliminarProducto();
    }, [eliminar]);

    const eliminarProductoPregunta = async () => {
        mostraAlertaPregunta(setEliminar, `¿Deseas eliminar el producto ${datos.nombre} de forma permanente?`, "warning");
    };

    const eliminarProducto = async () => {
        if (!datos.id)
            mostraAlertaError("Seleccione un producto");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(ProductosEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(ProductosListar, setListaProductos);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        console.log(er);
                        let msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. ';
                                    });
                                }
                                break;
                            case 404:
                                msjError = er.response.data.error;
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
        setEliminar(false);
    };

    return (
        <button type="button" className="btn btn-danger btn-sm" style={{ minWidth: "35px" }}  onClick={eliminarProductoPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
};

export default EliminarProducto;